import apiHeader from '@/helpers/apiHeader';
import { getDeviceId } from '@/helpers/deviceId';

const authService = {
  login(params) {
    return apiHeader.post('auth/login', params);
  },
  loginWithAzure() {
    return apiHeader.get('auth/login-with-azure')
  },
  loginWithSso(type, redirectUri) {
    const params = redirectUri ? { redirect_uri: redirectUri } : {};
    return apiHeader.get(`auth/sso/${type}`, { params })
  },
  convertSsoToken(type, code) {
    return apiHeader.get(`auth/sso/${type}/convert`, { params: { code } })
  },
  // FE-driven SSO callback: kirim authorization code + state dari Keycloak
  // ke backend untuk ditukar jadi JWT (client_secret & code_verifier tetap di backend).
  ssoCallback(type, code, state) {
    return apiHeader.get(`auth/sso/${type}/callback`, { params: { code, state } })
  },
  forgotPassword(params) {
    return apiHeader.post('auth/forgot-password', params);
  },
  resetPassword(params) {
    return apiHeader.post('auth/reset-password', params);
  },
  verifyResetToken(params) {
    return apiHeader.post('auth/verify-reset-token', params);
  },
  forceChangePassword(params) {
    return apiHeader.post('auth/force-change-password', params);
  },
  // Register/bind perangkat setelah login berhasil.
  // Header X-Device-ID & params device_id otomatis dari apiHeader deviceId helper.
  deviceLogin() {
    return apiHeader.get('auth/device-login', {
      params: { device_id: getDeviceId() },
    });
  },
  // Cabut sesi perangkat — default dari device_id lokal, bisa override untuk revoke sesi device lain
  revokeDevice(deviceId) {
    return apiHeader.get('auth/revoke-device', {
      params: { device_id: deviceId || getDeviceId() },
    });
  },
  logout() {
    return apiHeader.get('auth/logout');
  },
  getListRolePermission() {
    return apiHeader.get('users/list-role-permission');
  },
  // Get navbar profile
  getNavbarProfile() {
    return apiHeader.get('/navbar/my-profile');
  },

  // Change profile photo
  changeProfilePhoto(formData) {
    return apiHeader.post('/navbar/my-profile/change-photo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  // Update profile
  updateProfile(data) {
    return apiHeader.post('/navbar/my-profile', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
};

export default authService;
